export const ISBN_PATTERN_STRING = '^(97[89]-?)?(\\d-?){9}(\\d|[Xx])$';

export const ISBN_PATTERN = new RegExp(ISBN_PATTERN_STRING);

export function normalizeIsbnDigits(input: string): string {
  return input.trim().replace(/[\s-]+/g, '').toUpperCase();
}

export function matchesIsbnPattern(input: string): boolean {
  return ISBN_PATTERN.test(input.trim());
}

function isValidIsbn10(digits: string): boolean {
  if (!/^(?:\d{9}[\dX])$/.test(digits)) {
    return false;
  }
  let checksum = 0;
  for (let i = 0; i < 9; i++) {
    checksum += (i + 1) * Number(digits.charAt(i));
  }
  if (digits.charAt(9) === 'X') {
    checksum += 10 * 10;
  } else {
    checksum += 10 * Number(digits.charAt(9));
  }
  return checksum % 11 === 0;
}

function isValidIsbn13(digits: string): boolean {
  if (!/^\d{13}$/.test(digits)) {
    return false;
  }
  let checksum = 0;
  const factor = [1, 3];
  for (let i = 0; i < 12; i++) {
    checksum += factor[i % 2] * Number(digits.charAt(i));
  }
  const expected = (10 - (checksum % 10)) % 10;
  return Number(digits.charAt(12)) === expected;
}

function checkIsbnChecksumDigits(digits: string): boolean {
  if (digits.length === 10) {
    return isValidIsbn10(digits);
  }
  if (digits.length === 13) {
    return isValidIsbn13(digits);
  }
  return false;
}

export function isValidIsbnChecksum(input: string): boolean {
  const digits = normalizeIsbnDigits(input);
  if (!digits) {
    return false;
  }
  return checkIsbnChecksumDigits(digits);
}
